import {
  CancelProductBoughtUsecase,
  CancelProductBoughtUsecaseImp,
} from 'domain/usecases/cancel-product-bought-usecase';
import { makeHttpCancelProductBoughtRepository } from '../repositories/http/product-http-repository-factory';

export const makeCancelProductBoughtUsecase = (): CancelProductBoughtUsecase => {
  return new CancelProductBoughtUsecaseImp(makeHttpCancelProductBoughtRepository());
};
